module.exports = __webpack_public_path__ + "static/media/domestic_shipping.e01ea62c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-order/scrap-step/benefits/domestic_shipping.png
// module id = 1971
// module chunks = 0